angular
  .module(
    'app.controllers', []
  );



// WEBPACK FOOTER //
// ./scripts/shared/controllers/module.js